module.exports = __webpack_public_path__ + "img/scale-region.df1cb500.png";